import moment from 'moment'
import { Compare } from './Compare'

// How do we display bottom legends, in order to be able to display a line graph we need at least 2 points
// So we need to force the user to have at least 1 day gap when selecting the date range
// If we have 2 days, then we display bottom legends as e.g.: Friday, Saturday
// If we have 7 days, we display all week days
// If we have more than 7 days, then we display
const getOrCreateTooltip = (chart) => {
    let tooltipEl = chart.canvas.parentNode.querySelector('div')

    if (!tooltipEl) {
        tooltipEl = document.createElement('div')
        tooltipEl.classList.add('compare__g-tooltip')
        tooltipEl.style.opacity = 1
        tooltipEl.style.transform = 'translate(-50%, 0)'
        const table = document.createElement('table')
        tooltipEl.appendChild(table)
        chart.canvas.parentNode.appendChild(tooltipEl)
    }
  
    return tooltipEl
}
  
const externalTooltipHandler = (context) => {
    // Tooltip Element
    const {chart, tooltip} = context
    const tooltipEl = getOrCreateTooltip(chart)
  
    // Hide if no tooltip
    if (tooltip.opacity === 0) {
      tooltipEl.style.opacity = 0
      return
    }
  
    const currentDataIndex = tooltip.dataPoints[0].dataIndex
    const currentDataset = tooltip.dataPoints[0].dataset
    const currentDatasetPointData = currentDataset.data[currentDataIndex]

    // Set Text
    if (tooltip.body) {
      const titleLines = tooltip.title || []
      const bodyLines = tooltip.body.map(b => b.lines)
      const tableHead = document.createElement('thead')
  
      titleLines.forEach(() => {
        const tr = document.createElement('tr')
        const th = document.createElement('th')
        const dateFormat = currentDataset.dateGroupsAsMonths ? 'MMMM' : 'll'
        const spanDate = document.createElement('span')
        spanDate.classList.add('tooltip-airport__date')
        spanDate.appendChild(document.createTextNode(moment(currentDatasetPointData.x).format(dateFormat)))

        const tooltipAirport = document.createElement('div')
        const tooltipAirportColour = document.createElement('span')

        let airportCodeString = document.createTextNode(currentDataset.airportCode)
        if (bodyLines.length > 1) {
            airportCodeString = document.createTextNode(bodyLines.map(value => {
                const indexOfDivider = value[0].indexOf(':')
                return value[0].substring(0, indexOfDivider)
            }).join(', '))
        }
        const tooltipAirportCode = document.createElement('span').appendChild(airportCodeString)

        tooltipAirport.classList.add('tooltip-airport')
        tooltipAirportColour.classList.add('tooltip-airport__colour')
        tooltipAirportColour.style.backgroundColor = currentDataset.borderColor
        
        tooltipAirport.appendChild(tooltipAirportColour)
        tooltipAirport.appendChild(tooltipAirportCode)

        th.appendChild(tooltipAirport)
        th.appendChild(spanDate)
  
        tr.appendChild(th)
        tableHead.appendChild(tr)
      })
  
      const tableBody = document.createElement('tbody')
        let totalNumberOfAlerts = currentDatasetPointData.alerts.length
        if (currentDataset.enableAvsecAlerts) {
            totalNumberOfAlerts = totalNumberOfAlerts + currentDatasetPointData.aviationAlerts.length
        }

        const span = document.createElement('span')
        span.classList.add('is-alert')

        const tr = document.createElement('tr')
        const td = document.createElement('td')
        const text = document.createTextNode(totalNumberOfAlerts)
    
        td.appendChild(span)
        td.appendChild(text)
        tr.appendChild(td)
        tableBody.appendChild(tr)

        if (totalNumberOfAlerts > 0) {
            const span = document.createElement('span')
            span.classList.add('more-details')
            const text = document.createTextNode('Click For Details')
            span.appendChild(text)
            
            const tr = document.createElement('tr')
            const td = document.createElement('td')
            
            td.appendChild(span)
            tr.appendChild(td)
            tableBody.appendChild(tr)
        }
  
        const tableRoot = tooltipEl.querySelector('table')
    
        // Remove old children
        while (tableRoot.firstChild) {
            tableRoot.firstChild.remove()
        }
    
        // Add new children
        tableRoot.appendChild(tableHead)
        tableRoot.appendChild(tableBody)
    }
  
    const {offsetLeft: positionX, offsetTop: positionY} = chart.canvas
  
    // Display, position, and set styles for font
    tooltipEl.style.opacity = 1
    tooltipEl.style.left = positionX + tooltip.caretX + 'px'
    tooltipEl.style.top = positionY + tooltip.caretY + 10 + 'px' // +10 just for some better hovered datapoint display
    tooltipEl.style.font = tooltip.options.bodyFont.string
    // tooltipEl.style.padding = tooltip.options.padding + 'px ' + tooltip.options.padding + 'px'
}

export const CHART_OPTIONS = {
    maintainAspectRatio: false,
    scales: {
        x: {
            type: 'time',
            time: {
                minUnit: 'day'
            },
            grid: {
                color: 'rgba(52, 56, 66, 1)'
            } 
        },
        y: {
            beginAtZero: true,
            grid: {
                color: 'rgba(52, 56, 66, 1)'
            },
            ticks: {
                precision: 0
            }                      
        }
    },
    plugins: {
        legend: {
            display: false
        },
        tooltip: {
            enabled: false,
            position: 'nearest',
            external: externalTooltipHandler
        }
    },
    elements: {
        point: {
            pointBackgroundColor: 'rgba(19, 19, 24, 1)',
            pointHoverRadius: 6,
            pointHitRadius: 10,
        }
    },
    onClick: (event) => {
        const points = event.chart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, true)
        if (points.length) {
            const firstPoint = points[0]
            const dataset = event.chart.data.datasets[firstPoint.datasetIndex]
            
            Compare.showEntryDetails(dataset.ICAOCode, dataset.data[firstPoint.index].x)
            
            console.log(`Clicked on chart dataset point for the ICAO: '${dataset.ICAOCode}' Airport`, dataset.data[firstPoint.index])
            console.log(dataset)
        }
    }
}